<template>
  <span class="default" :class="[inactive ? 'inactive' : 'gray-3']"></span>
</template>

<script>
export default {
  name: 'VBullet',
  props: {
    inactive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.default {
  position: absolute;
  width: 3px;
  height: 3px;
  left: 0;
  right: 0;
  top: 7px;
  border-radius: 1.5px;
}

.gray-3 {
  background-color: $gray-3;
}

.inactive {
  background-color: $light-gray-4;
}
</style>